export default __webpack_public_path__ + "static/media/I0002.21dadee0.png";